import React from "react";

const Arrow = () => {
  return (
    <svg
      width="40"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        opacity: 1,
        overflow: "hidden",
        borderRadius: 150,
        background: "linear-gradient(to right, transparent 45%, grey )",
      }}
    >
      <g>
        <path
          d="M47.3001 54.2718C48.1168 55.0711 49.4335 55.0711 50.2501 54.2718L64.1001 40.7165C64.7501 40.0803 64.7501 39.0527 64.1001 38.4165L50.2501 24.8612C49.4335 24.0619 48.1168 24.0619 47.3001 24.8612C46.4835 25.6605 46.4835 26.9491 47.3001 27.7484L59.3668 39.5747L47.2835 51.4009C46.4835 52.1839 46.4835 53.4889 47.3001 54.2718Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default Arrow;
